import { useCallback, useMemo } from "react";
import useWeb3 from "../useWeb3";
import { getVestingContract } from "../../utils/contractHelpers";
import Environment from "../../utils/Environment";
import Web3 from "web3";
import { useWeb3React } from "@web3-react/core";

const ClaimVestTokens = () => {
  const web3 = useWeb3();
  // const web3 = useMemo(
  //   () =>
  //     new Web3(
  //       "https://dry-quiet-sound.arbitrum-mainnet.quiknode.pro/ec48bb1798a955bcdf75c64bc9fab428add0745e/"
  //     ),
  //   []
  // );

  // const web3 = new Web3(Environment.rpc);
  const { chainId } = useWeb3React();
  const vesting = Environment.Vesting;
  const vestingContract = getVestingContract(vesting, web3);

  const claimVestTokens = useCallback(
    async (
      account,
      proof,
      amount,
      random,
      deadline,
      signature,
      setLoader,
      setLoaderMsg,
      setRefresh,
      refetchClaimsData,
      refetchClaimsTimesData,
      refetchVestingInfo,
      handleShow1,
      refresh,
      handleShow2,
      callAirdrop
    ) => {
      if (!account || !proof || !amount || !random || !deadline || !signature)
        return;
      try {
        console.log("Claiming All with params: ", {
          proof,
          amount,
          random,
          deadline,
          signature,
          chainId,
        });

        const gasEstimate = await vestingContract.methods
          .claim(proof, amount, random, deadline, signature)
          .estimateGas({ from: account });

        let gasPrice = await web3.eth.getGasPrice();
        // optional: add a little buffer
        gasPrice = parseInt(gasPrice) + 50000000;

        let txHash;

        const claimAllRes = await vestingContract.methods
          .claim(proof, amount, random, deadline, signature)
          .send({ from: account, gas: gasEstimate, gasPrice })
          .on("transactionHash", (tx) => {
            txHash = tx;
            setLoaderMsg("Verifying transaction...");
            setTimeout(() => {
              setLoader(false);
              setLoaderMsg("");
              setRefresh(!refresh);
              refetchClaimsData();
              refetchClaimsTimesData();
              refetchVestingInfo();
              handleShow1();
              callAirdrop(account);
            }, 10000);
          })
          .on("receipt", async function (receipt) {
            try {
              console.log("Claim transaction successful: ", receipt, txHash);
              txHash = receipt.transactionHash;
            } catch (err) {
              console.error("Error in claim receipt: ", err);
              setLoader(false);
              setLoaderMsg("");
              handleShow2();
            }
          });

        console.log("claimAll response: ", claimAllRes);

        return claimAllRes;
      } catch (error) {
        console.error(`Error during claiming : `, error);
        throw error;
      }
    },
    [vestingContract]
  );

  return { claimVestTokens: claimVestTokens };
};

export default ClaimVestTokens;
